import { getRefreshPromise } from 'app/http';
import { invalidateSession } from 'app/http/sessionInvalidation';
import { downloadBlobResponseAsFile } from './downloadBlobResponseAsFile';

const fetchWithTokenRefresh = async (url: string) => {
  const response = await fetch(url);
  if (response.status !== 418) {
    return response;
  }
  const refreshResult = await getRefreshPromise();
  if (refreshResult.kind === 'auth-failure') {
    invalidateSession({ broadcast: true });
    return response;
  }
  if (refreshResult.kind === 'success') {
    return await fetch(url);
  }
  return response;
};

const fetchDownload = async (url: string) => {
  const response = await fetchWithTokenRefresh(url);
  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }
  return response;
};

export const downloadFromUrl = async (url: string, fileName: string) => {
  const response = await fetchDownload(url);
  downloadBlobResponseAsFile(await response.blob(), fileName);
};
